/** Department display name → primary workflow route (queue page). */
export const DEPARTMENT_NAV_PATH: Record<string, string> = {
  Design: '/design',
  Production: '/production',
  Finishing: '/finishing',
  Installation: '/installation',
  'Quality Check': '/qc',
};

export function departmentSettingsPath(department: string): string | undefined {
  const base = DEPARTMENT_NAV_PATH[department];
  return base ? `${base}/settings` : undefined;
}
